var Promise = require('bluebird');
var RepositoryAPI = require('../api/repository');
var Config = require('../api/config');

function createGuid() {
  //from http://stackoverflow.com/a/2117523/505832
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

var mod = (module.exports = angular.module('documents', [
  require('ng-file-upload'),
  'validator',
]));

mod.service('$docUpload', function (Upload, $document, $fileValidator) {
  this.GetAllowedUploadTypes = function (filter) {
    var allowed = $fileValidator.GetAllowedTypesByFilter(filter);
    allowed.contentTypes = allowed.contentTypes.toString();

    return allowed;
  };

  this.HandleUploadAction = function (
    files,
    validationFilter,
    onErrorCallback,
    onPendingCallback,
    onSuccessCallback
  ) {
    // First, check files are allowed to be uploaded
    var errFiles = [];
    files.forEach(function (file) {
      if (!$fileValidator.ValidateContentType(file, validationFilter)) {
        errFiles.push(file);
      }
    });

    if (errFiles.length > 0) {
      onErrorCallback(errFiles);
      return;
    }

    // File was accepted by frontend validation, so now let's try to send it to the document repository
    errFiles = [];
    var serverRejectedFileCallback = function (file, responseStatus) {
      if (responseStatus === 400) {
        errFiles.push(file);
        onErrorCallback(errFiles);
      }
    };

    var upload = this.Upload(files, undefined, serverRejectedFileCallback);
    if (upload !== undefined) {
      upload.then(function () {
        if (errFiles.length === 0) {
          var requests = files.map(function (file) {
            return onPendingCallback(file);
          });
          Promise.all(requests).then(function (response) {
            if (response !== undefined && response.length > 0) {
              onSuccessCallback();
            }
          });
        }
      });
    }
  };

  this.Upload = function (files, opts, errorNotify) {
    if (files === undefined || files.length === 0) {
      return;
    }

    var options = {
      public: false,
    };

    // update options.
    for (var key in opts) {
      options[key] = opts[key];
    }

    // create id for each file.
    files.forEach(function (file) {
      file.id = createGuid();
    });

    // get token to upload with.
    return RepositoryAPI.GetRepoToken().then(function (token) {
      // upload each file, and return promise for each.
      var all = files.map(function (file) {
        var url =
          window.conf.doc_repos_url +
          'up/' +
          encodeURIComponent(file.id) +
          '?t=' +
          encodeURIComponent(token);
        if (options.public) {
          url += '&isPublic=true';
        }

        file.upload = Upload.upload({
          url: url,
          data: { file: file },
        });

        var p = file.upload.then(
          function (response) {
            file.result = response.data;
          },
          function (response) {
            if (response.status > 0) {
              file.errorMsg = response.status + ': ' + response.data;

              if (errorNotify !== undefined) {
                errorNotify(file, response.status);
              }
            }
          },
          function (evt) {
            // progress
            file.progress = Math.min(
              100,
              parseInt((100.0 * evt.loaded) / evt.total)
            );
          }
        );

        return p;
      });

      return Promise.all(all);
    });
  };

  this.Download = function (obj) {
    RepositoryAPI.GetRepoToken(obj.documentId || obj.blobId || obj.id).then(
      function (token) {
        var link = Config.docReposUrl() + obj.datalink;
        link += '?t=' + encodeURIComponent(token);
        var a = angular.element('<a download></a>');
        a.attr('href', link);
        a.attr('target', '_blank');
        $document.find('body').append(a);

        setTimeout(function () {
          a[0].click();
          a.remove();
        }, 0);
      }
    );
  };
});
